import(/* webpackMode: "eager" */ "/app/packages/web/src/app/page.tsx");
